/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ExternalMCPTool = {
  /**
   * Annotations for the tool
   */
  annotations?: any | undefined;
  /**
   * Description of the tool
   */
  description?: string | undefined;
  /**
   * Input schema for the tool
   */
  inputSchema?: any | undefined;
  /**
   * Name of the tool
   */
  name?: string | undefined;
};

/** @internal */
export const ExternalMCPTool$inboundSchema: z.ZodMiniType<
  ExternalMCPTool,
  unknown
> = z.pipe(
  z.object({
    annotations: z.optional(z.any()),
    description: z.optional(z.string()),
    input_schema: z.optional(z.any()),
    name: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "input_schema": "inputSchema",
    });
  }),
);

export function externalMCPToolFromJSON(
  jsonString: string,
): SafeParseResult<ExternalMCPTool, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExternalMCPTool$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalMCPTool' from JSON`,
  );
}
